import React from "react";
import PixelIcon from "../PixelIcon";

// Preserve MessageBox's small semantic API while routing its artwork
// through the same swappable period-icon manifest as the rest of the UI.

function MsgIcon({ kind = "question", size = 32, className }) {
  return (
    <PixelIcon name={`message-${kind}`} size={size} className={className} />
  );
}

export default MsgIcon;
